'use strict';

angular.module('webmailWrapper')
.controller(
    'EmailMailboxEditCtrl',
    function ($scope, $modalInstance, mailbox, mailboxModel, spamProfiles, emailHelper, storageQuotaOptions, alertManager, translationProvider) {
        var autoResponderTimeframe = mailbox.autoResponder.start !== null;

        $scope.mailbox = mailbox;
        $scope.spamProfiles = spamProfiles;
        $scope.storageQuotaOptions = storageQuotaOptions;
        $scope.isAdmin = mailbox.isAdmin;

        if ($scope.mailbox.autoResponder.start !== null) {
            $scope.mailbox.autoResponder.start = $scope.mailbox.autoResponder.start.split('T')[0] + 'T12:00:00Z';
        }

        if ($scope.mailbox.autoResponder.end !== null) {
            $scope.mailbox.autoResponder.end = $scope.mailbox.autoResponder.end.split('T')[0] + 'T12:00:00Z';
        }

        $scope.data = {
            additionalForwarder: (mailbox.forwarderTargets.length > 0),
            datepickerOpen: {
                end: false,
                start: false
            },
            password: '',
            passwortRepeat: '',
            spamProfile: emailHelper.getSelectedSpamProfile(spamProfiles, mailbox.spamFilter),

            get autoResponderTimeframe() {
                return autoResponderTimeframe;
            },
            set autoResponderTimeframe(value) {
                if (value) {
                    autoResponderTimeframe = true;
                    $scope.mailbox.autoResponder.start = (new Date()).toISOString().split('T')[0] + 'T12:00:00Z';
                    $scope.mailbox.autoResponder.end = (new Date()).toISOString().split('T')[0] + 'T12:00:00Z';
                } else {
                    autoResponderTimeframe = false;
                    $scope.mailbox.autoResponder.start = null;
                    $scope.mailbox.autoResponder.end = null;
                }
            }
        };

        $scope.selectSpamProfile = function(spamProfile) {
            if (spamProfile.custom) {
                return;
            }
            angular.extend(mailbox.spamFilter, spamProfile.values);
        };

        $scope.submit = function(form) {
            $scope.$broadcast('show-errors-check-validity');
            if (form.$invalid) {
                return;
            }

            if (!$scope.data.additionalForwarder) {
                $scope.mailbox.forwarderTargets = [];
            }

            var mailboxData = JSON.parse(JSON.stringify($scope.mailbox));

            if (mailboxData.autoResponder.start !== null) {
                mailboxData.autoResponder.start = mailboxData.autoResponder.start.split('T')[0] + 'T00:00:00Z';
            }

            if (mailboxData.autoResponder.end !== null) {
                mailboxData.autoResponder.end = mailboxData.autoResponder.end.split('T')[0] + 'T23:59:59Z';
            }

            mailboxModel.update(
                mailboxData,
                [undefined, null, ''].indexOf($scope.data.password) < 0 ? $scope.data.password : undefined
            )
            .then(
                function() {
                    alertManager.success(translationProvider.instant('TR_070525-5929ea_TR'));
                    $modalInstance.close();
                },
                function() {
                    alertManager.error(translationProvider.instant('TR_070525-fbbcfc_TR'));
                }
            );
        };
    }
);
